import { render, staticRenderFns } from "./block-documents-sign-list.vue?vue&type=template&id=12a95c9a&scoped=true&lang=pug"
import script from "./block-documents-sign-list.vue?vue&type=script&lang=js"
export * from "./block-documents-sign-list.vue?vue&type=script&lang=js"
import style0 from "./block-documents-sign-list.vue?vue&type=style&index=0&id=12a95c9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a95c9a",
  null
  
)

export default component.exports